var exports = {
  "Og": "ChannelMessages.module__messagesWrapper___UW9faE",
  "gs": "ChannelMessages.module__scrollerContainer___UW9faE",
  "aE": "ChannelMessages.module__bottomFade___UW9faE",
  "yY": "ChannelMessages.module__bottomFadeStatusAtBottom___UW9faE",
  "K9": "ChannelMessages.module__bottomFadeStatusScrolled___UW9faE",
  "gT": "ChannelMessages.module__scrollerContent___UW9faE",
  "lB": "ChannelMessages.module__scrollerSpacer___UW9faE",
  "xo": "ChannelMessages.module__scrollerSpacerAfterFiller___UW9faE",
  "pi": "ChannelMessages.module__fillerBuffer___UW9faE",
  "CU": "ChannelMessages.module__groupSpacer___UW9faE",
  "$P": "ChannelMessages.module__groupSpacerHalf___UW9faE",
  "bv": "ChannelMessages.module__scrollerInner___UW9faE",
  "eb": "ChannelMessages.module__newMessagesBar___UW9faE",
  "mC": "ChannelMessages.module__newMessagesBarBanner___UW9faE",
  "xp": "ChannelMessages.module__newMessagesBarBannerText___UW9faE",
  "su": "ChannelMessages.module__newMessagesBarBannerAction___UW9faE",
  "G6": "ChannelMessages.module__messageBottomPill___UW9faE",
  "Sg": "ChannelMessages.module__jumpToPresentBar___UW9faE",
  "RQ": "ChannelMessages.module__newMessagesBarText___UW9faE",
  "As": "ChannelMessages.module__loadErrorBar___UW9faE",
  "Ku": "ChannelMessages.module__newMessagesBarAction___UW9faE",
  "WB": "ChannelMessages.module__unreadSlot___UW9faE",
};

module.exports = exports;
